<template>
  <div
    class="landing-flexible-item text-start grid grid-cols-1 md:grid-cols-2 gap-4 rounded p-4"
  >
    <div class="flex flex-col">
      <div
        class="flex flex-row items-center bg-orange-500 gap-2 rounded p-2 mb-4"
      >
        <div
          class="flexible-item-icon-container rounded flex items-center justify-center size-8"
        >
          <Icon :name="props.icon" class="size-5 text-white" />
        </div>
        <div>
          <h3 class="text-white text-md font-bold">
            {{ props.title }}
          </h3>
          <p class="text-xs text-white">
            {{ props.titleDescription }}
          </p>
        </div>
      </div>
      <div class="grid grid-cols-1 gap-4">
        <template v-for="(text, index) in mainTexts" :key="index">
          <div class="flex flex-row items-center gap-2">
            <div
              class="min-h-4 min-w-4 bg-orange-500 rounded-full flex items-center justify-center"
            >
              <Icon
                name="fluent:checkmark-16-filled"
                class="size-3 text-white"
              />
            </div>
            <h4 class="text-xs text-slate-600">
              {{ text }}
            </h4>
          </div>
        </template>
      </div>
    </div>
    <div class="flex flex-col">
      <div
        class="h-14 flex flex-row items-center bg-white gap-2 rounded p-2 mb-4"
      >
        <div class="h-full w-1 bg-orange-500"></div>
        <h3 class="text-orange-500 text-md font-bold">
          {{ props.whyTitle }}
        </h3>
      </div>
      <div class="grid grid-cols-1 bg-white rounded p-3 gap-4">
        <template v-for="(text, index) in whyTexts" :key="index">
          <h4 class="text-xs text-slate-600">
            {{ text }}
          </h4>
        </template>
      </div>
      <NuxtLink
        v-if="props.videoUrl"
        :to="props.videoUrl"
        class="flex flex-row items-center justify-between bg-orange-500 text-white text-sm rounded py-2 px-4 mt-4"
        aria-label="360sosyal Tanıtım Videosu"
      >
        Tanıtım Videosu
        <div
          class="flex items-center justify-center bg-orange-400 rounded-md size-6"
        >
          <Icon name="tabler:arrow-up-right" class="size-6 text-white" />
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    icon?: string
    title?: string
    titleDescription?: string
    whyTitle?: string
    whyTexts?: string[]
    mainTexts?: string[]
    videoUrl?: string
  }>(),
  {
    icon: '',
    title: '',
    titleDescription: '',
    whyTitle: '',
    whyTexts: () => [],
    mainTexts: () => [],
    videoUrl: '',
  },
)
</script>

<style scoped>
.landing-flexible-item {
  background: rgb(255, 216, 178);
  background: linear-gradient(
    180deg,
    rgba(255, 182, 108, 0.304) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}
.flexible-item-icon-container {
  background-color: #ffb078;
}
</style>
